import React from 'react';

import { flagStyles } from '../settings';

const SvgMR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3576px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMR;
